import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ActionDialogData {
  dialogIcon?: string;
  description: string;
  enableDisplayAction?: boolean;
  // Optional: Pre-defined action buttons
  actions?: {
    label: string;
    callback: () => void;
    class?: string;
  }[];
}

@Component({
  selector: 'app-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.scss']
})
export class ActionDialogComponent {
  dialogIcon: string;
  description: string;
  enableDisplayAction: boolean;
  actions: any[];

  constructor(
    public dialogRef: MatDialogRef<ActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionDialogData
  ) {
    this.dialogIcon = data.dialogIcon || 'info';
    this.description = data.description || '';
    this.enableDisplayAction = data.enableDisplayAction ?? true;
    this.actions = data.actions || [];
  }

  onActionClick(action: any): void {
    if (action.callback) {
      action.callback();
    }
    // Optionally close dialog after action
    this.dialogRef.close(action);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}

